import { useCallback, useEffect, useState } from 'react';
import { logWarn } from '../lib/log';

const CART_KEY = 'beautyou_cart';
const sameItem = (a, id, lineColor) => a.id === id && a.line_color === lineColor;

const mergeItems = (prev, items, qtyOf) => {
  const next = prev.map((i) => ({ ...i }));
  items.forEach((p) => {
    const qty = qtyOf(p);
    const idx = next.findIndex((i) => sameItem(i, p.id, p.line_color));
    if (idx >= 0) next[idx].quantity += qty;
    else next.push({ ...p, quantity: qty });
  });
  return next;
};

const readSavedCart = () => {
  try {
    const saved = localStorage.getItem(CART_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    logWarn('Could not restore cart:', error);
    return [];
  }
};

export const useCart = () => {
  const [cart, setCart] = useState(readSavedCart);

  useEffect(() => {
    try {
      if (cart.length > 0) localStorage.setItem(CART_KEY, JSON.stringify(cart));
      else localStorage.removeItem(CART_KEY);
    } catch (error) {
      logWarn('LocalStorage not available:', error);
    }
  }, [cart]);

  const addItems = useCallback((items, qtyOf = () => 1) => setCart((prev) => mergeItems(prev, items, qtyOf)), []);
  const removeFromCart = useCallback((id, lineColor) => setCart((prev) => prev.filter((i) => !sameItem(i, id, lineColor))), []);
  const clearCart = useCallback(() => {
    setCart([]);
    try { localStorage.removeItem(CART_KEY); } catch (error) { logWarn('LocalStorage not available:', error); }
  }, []);

  const cartCount = cart.reduce((n, i) => n + i.quantity, 0);
  const cartTotal = cart.reduce((n, i) => n + i.price * i.quantity, 0);

  return { cart, setCart, addItems, removeFromCart, clearCart, cartCount, cartTotal };
};

export default useCart;
